import { dateTime } from "@/lib/fmt";
const STYLE = `body{font-family:'Plus Jakarta Sans',sans-serif;color:#1C1917;max-width:780px;margin:32px auto;padding:0 24px}
.brand{font-family:'Playfair Display',serif;font-size:14px;letter-spacing:.2em;text-transform:uppercase;color:#9E2A2B}
h1{font-family:'Playfair Display',serif;font-size:32px;margin:8px 0 4px}.sub{color:#6B655F;font-size:13px;border-bottom:2px solid #1C1917;padding-bottom:14px;margin-bottom:8px}
h2{font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:#6B655F;margin:24px 0 8px;border-bottom:1px solid #E6E1D7;padding-bottom:6px}
table{width:100%;border-collapse:collapse;font-size:13px}th{text-align:left;width:38%;color:#6B655F;font-weight:400;padding:5px 0;vertical-align:top}td{padding:5px 0}
p{font-size:13px;line-height:1.6;white-space:pre-line}.foot{margin-top:40px;font-size:11px;color:#6B655F;border-top:1px solid #E6E1D7;padding-top:10px}`;

// Builds the print window with DOM APIs + textContent only, so record data can never become markup or script.
export function el(doc, tag, props = {}, children = []) {
  const n = doc.createElement(tag);
  Object.entries(props).forEach(([k, v]) => (k === "text" ? (n.textContent = String(v ?? "")) : n.setAttribute(k, v)));
  children.forEach((c) => c && n.appendChild(c));
  return n;
}

export function openPrintWindow(title, buildBody, delay = 500) {
  const w = window.open("", "_blank");
  if (!w) { alert("Please allow pop-ups to print."); return; }
  const d = w.document;
  d.title = String(title ?? "");
  d.head.appendChild(el(d, "link", { rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600&family=Plus+Jakarta+Sans:wght@400;600&display=swap" }));
  d.head.appendChild(el(d, "style", { text: STYLE }));
  buildBody(d).forEach((n) => d.body.appendChild(n));
  setTimeout(() => w.print(), delay);
}

export function printDoc(title, subtitle, sections) {
  openPrintWindow(title, (d) => [
    el(d, "div", { class: "brand", text: "86'd" }), el(d, "h1", { text: title }), el(d, "div", { class: "sub", text: subtitle }),
    ...sections.flatMap((s) => [
      el(d, "h2", { text: s.title }),
      s.rows && el(d, "table", {}, s.rows.filter((r) => r[1] !== undefined && r[1] !== null && r[1] !== "")
        .map(([k, v]) => el(d, "tr", {}, [el(d, "th", { text: k }), el(d, "td", { text: v })]))),
      s.text && el(d, "p", { text: s.text }),
    ]),
    el(d, "div", { class: "foot", text: `Generated ${dateTime(new Date())} · 86'd Restaurant Manager OS` }),
  ]);
}
